import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {environment} from './environments/environment';
import {AppModule} from './app/app.module';
import {loadOneSignal} from './app/util/onesignal-loader';

if (environment.production) {
  enableProdMode();
}

window.addEventListener('CookiebotOnAccept', () => {
  loadOneSignal();
});

// If user already accepted marketing cookies, load immediately
if (window.Cookiebot?.consent?.marketing) {
  setTimeout(() => loadOneSignal(), 0);
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
